import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import Footer, { FooterMobile } from "../components/Footer";

import { Colors } from "../ColorConstants";
import LocationSection from "../components/Booking/Location";
import VisitHours from "../components/Booking/VisitHours";
import FeedbackShare from "../components/Booking/FeedbackShare";
import { useNavigate } from "react-router-dom";

// import { truncatedText, VisitingHour } from "../tempConst";
import AquaContact from "../components/AquaZone/AquaContact";
import AquaGames from "../components/AquaZone/AquaGameItem";
import TruncatedText from "../components/AquaZone/TruncatedDescription";
import { toast } from "react-toastify";
import { getAquaGames } from "../services/aquaServices";
import { signUpGuest } from "../services/guestServices";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
import CustomLoader from "../components/Loader";
import RideMap from "../components/AquaZone/RideMap";
import RideInfoModal from "../components/AquaZone/RideMapInfoModal";
import ViewMapModal from "../components/AquaZone/ViewMapModal";
import { BackArrow, BackButton } from "../assets/icons";

const AquaZone = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [data, setData] = useState({});
  const [outlet, setOutlet] = useState({});
  const [loading, setLoading] = useState(false);
  const [rideInfo, setRideInfo] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const type = localStorage.getItem("type");
    const shouldCallGuestApi = type === null || type === "guest";
    fetchAquaGames();
    if (shouldCallGuestApi) {
      fetchSignUpData();
    }
  }, []);

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "AquaZone Products Page" });
  }, []);

  const fetchSignUpData = async () => {
    setLoading(true);
    try {
      let guestId = localStorage.getItem("guestId");
      let res = await signUpGuest(guestId || "");
      localStorage.setItem("token", res?.data?.data?.token);
      localStorage.setItem("type", res?.data?.data?.type);
      localStorage.setItem("guestId", res?.data?.data?._id);
    } catch (err) {
      toast.error("Error while fetching data");
    } finally {
      setLoading(false);
    }
  };

  const fetchAquaGames = async () => {
    setLoading(true);
    try {
      let res = await getAquaGames();
      setData(res?.data?.data?.list);
      setOutlet(res?.data?.data?.outletInfo[0]);
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoading(false);
    }
  };

  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      {
        label: "Booking",
        path: ``,
      },
      {
        label: outlet?.name,
        path: ``,
      },
    ];
  };

  const handleBookAqua = (data) => {
    console.log(data);
    navigate(`/app/aquaProduct/${data?._id}`);
  };

  const handleClickInfo = () => {
    setRideInfo(!rideInfo);
  };

  const handleClickViewMap = () => {
    setViewModal(!viewModal);
  };

  const closeModal = () => {
    setViewModal(false);
  };

  return (
    <div>
      <BackImageContainer onClick={() => navigate(`/auth/home`)}>
        <BackImage src={BackButton} />
      </BackImageContainer>
      <BannerContainer image={outlet?.images?.[0].url} />
      <BreadCrumb
        items={getBreadCrumbData()}
        activeItem={outlet?.name}
        isButton={false}
      />
      <AquazonePageContainer>
        <AquazoneDetailsContainer>
          <AquazoneParkDescription>
            <ParkNameContainer>
              <ParkName>{outlet.name}</ParkName>
              <FeedbackWrapper>
                <FeedbackShare
                  share={false}
                  email={outlet?.email}
                  phone={outlet?.reservationNumber}
                />
              </FeedbackWrapper>
            </ParkNameContainer>
            <ParkDescriptionText>{outlet?.description}</ParkDescriptionText>
            <TruncatedText
              text={outlet?.description}
              sentences={1}
              onClick={toggleExpansion}
              expanded={expanded}
            />
          </AquazoneParkDescription>
          <AquazoneOtherDescription>
            <VisitHours visitHours={outlet?.visitingHoursOrderBy} />
            <OtherDescriptionSubContainer>
              <LocationSection location={outlet?.address} marginTop="0rem" />
              <AquaContact contact={outlet?.reservationNumber} />
            </OtherDescriptionSubContainer>
            <RideMap onClickInfo={handleClickInfo} onViewMap={handleClickViewMap}/>
            {rideInfo && (
              <RideInfoModal setRideInfo={setRideInfo}/>
            )}
          </AquazoneOtherDescription>
        </AquazoneDetailsContainer>
        <GameListContainer>
          <AquaGames data={data} onBook={(val) => handleBookAqua(val)} />
        </GameListContainer>
      </AquazonePageContainer>
      {loading ? <CustomLoader /> : <></>}
      <FooterContainer>
        <Footer />
      </FooterContainer>
      <FooterMobile />
      <ViewMapModal isModalOpen={viewModal} closeModal={closeModal} mapImage={outlet?.mapImage}/>
    </div>
  );
};

const BannerContainer = styled.div`
  background-image: url(${(props) => props.image});
  height: 20rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  padding: 4.5rem 0;
  box-sizing: border-box;

  @media (max-width: 43.75rem) {
    height: 15rem;
  }
`;
const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;
const Overlay = styled.div`
  position: absolute;
  background-color: #0000005d;
  height: 20rem;
  width: 100%;
  top: 0;
  @media only screen and (max-width: 1024px) {
    height: 15rem;
  }
`;

const AquazonePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 1rem;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    padding-top: 1.5rem;
  }
`;

const AquazoneDetailsContainer = styled.div`
  width: 1024px;
  gap: 4rem;
  display: flex;
  padding-top: 2rem;
  @media only screen and (max-width: 1024px) {
    width: auto;

    flex-direction: column;
    gap: 1rem;
    padding: 0 0.8rem;
  }
`;

const AquazoneParkDescription = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 1.5rem;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    gap: 1rem;
  }
`;

const ParkNameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

const ParkName = styled.div`
  color: ${Colors.black};
  font-size: 2rem;
  font-weight: 700;
  @media only screen and (max-width: 1024px) {
    font-size: 2rem;
    font-weight: 700;
  }
`;
const FeedbackWrapper = styled.div`
  padding: 0.2rem 0rem;
  @media only screen and (max-width: 1024px) {
    padding: 0rem;
  }
`;

const ParkDescriptionText = styled.span`
  font-size: 1rem;
  font-weight: 400;
  text-align: justify;
  @media only screen and (max-width: 1024px) {
    // white-space: ${(props) => (props.expanded ? "normal" : "nowrap")};
    // overflow: ${(props) => (props.expanded ? "visible" : "hidden")};
    // text-overflow: ${(props) => !props.expanded && "ellipsis"};
    // max-height: ${(props) => (props.expanded ? "none" : "5.5em")};
    display: none;
  }
`;

const AquazoneOtherDescription = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  position: relative;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    // padding: 0 1rem;
  }
`;

const OtherDescriptionSubContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  // border: 1px solid red;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    // padding: 0 1rem;
  }
`;

const GameListContainer = styled.div`
  display: flex;
  width: 1024px;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
  // @media only screen and (max-width: 912px) {
  //   flex-direction: column;
  //   // padding: 0 1rem;
  //   border: 1px solid
  // }
  // @media only screen and (max-width: 450px) {
  //   // padding: 0 0.7rem;
  //   border: 1px solid red;
  // }
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
export default AquaZone;
